(() => {
  if (customElements.get('hc-anime-sale')) return;
  const starts = Date.parse('2026-10-10T00:00:00+11:00');
  const ends = Date.parse('2026-10-11T00:00:00+11:00');
  class AnimeSale extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.querySelector('[data-copy-code]').addEventListener('click', async () => {
        const status = this.querySelector('[data-copy-status]');
        try {
          await navigator.clipboard.writeText('ANIME10');
          status.textContent = 'Copied!';
        } catch {
          status.textContent = 'Please copy this code: ANIME10';
        }
      }, { signal: this.controller.signal });
      this.update();
      if (!this.hidden) this.timer = setInterval(() => this.update(), 1000);
      document.addEventListener('visibilitychange', () => this.update(), { signal: this.controller.signal });
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      this.controller.abort();
    }
    update() {
      const now = Date.now();
      this.hidden = now >= ends;
      if (this.hidden) {
        clearInterval(this.timer);
        return;
      }
      const upcoming = now < starts;
      this.querySelector('[data-sale-title]').textContent = upcoming
        ? 'Get ready for the 10.10 Anime Sale! Get 10% off on October 10.'
        : '10.10 Anime Sale! Get 10% off today only!';
      const remaining = Math.max(0, Math.ceil(((upcoming ? starts : ends) - now) / 1000));
      const days = Math.floor(remaining / 86400);
      const hours = Math.floor(remaining / 3600) % 24;
      const minutes = Math.floor(remaining / 60) % 60;
      const seconds = remaining % 60;
      this.querySelector('[data-sale-countdown]').textContent = `${upcoming ? 'Starts' : 'Ends'} in ${days ? days + 'd ' : ''}${hours}h ${minutes}m ${seconds}s.`;
    }
  }
  customElements.define('hc-anime-sale', AnimeSale);
})();
